
<div  class="pdf-print-view" [innerHTML]="admAcmData">
</div>
<div style="margin-top:20px; text-align: center;" class="d-flex justify-content-center">
	<button class="btn-style bg-green" (click)="downloadPdf(admAcmId)">Print</button>
</div>
